import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ExportersApi } from 'api';

/**
 *  Custom React Query hook to update a seller
 *
 * @param {number} id
 * @param {{ onSuccess?: () => void; onError?: (error: Error) => void }} options
 * @returns {import('@tanstack/react-query').UseMutationResult}
 */
export const useUpdateExporter = (id, { onSuccess, onError } = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => ExportersApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries(['exporters']);
      typeof onSuccess === 'function' && onSuccess();
    },
    onError: (error) => {
      typeof onError === 'function' && onError(error);
    },
  });
};
